<script setup lang="ts">
import { Marquee } from "@selemondev/vue3-marquee";
import "@selemondev/vue3-marquee/dist/style.css";

import {
  Smartphone,
  MessageSquare,
  ShoppingCart,
  Search,
  Zap,
  Shield,
  Eye,
  Building2,
  Cpu,
} from "lucide-vue-next";

interface sponsorsProps {
  icon: string;
  name: string;
}

const sponsors: sponsorsProps[] = [
  {
    icon: "smartphone",
    name: "华为",
  },
  {
    icon: "messageSquare",
    name: "腾讯",
  },
  {
    icon: "shoppingCart",
    name: "阿里巴巴",
  },
  {
    icon: "search",
    name: "百度",
  },
  {
    icon: "zap",
    name: "小米",
  },
  {
    icon: "shield",
    name: "海康威视",
  },
  {
    icon: "eye",
    name: "大华股份",
  },
  {
    icon: "building2",
    name: "中兴通讯",
  },
  {
    icon: "cpu",
    name: "紫光股份",
  },
];

const iconMap: Record<
  string,
  | typeof Smartphone
  | typeof MessageSquare
  | typeof ShoppingCart
  | typeof Search
  | typeof Zap
  | typeof Shield
  | typeof Eye
  | typeof Building2
  | typeof Cpu
> = {
  smartphone: Smartphone,
  messageSquare: MessageSquare,
  shoppingCart: ShoppingCart,
  search: Search,
  zap: Zap,
  shield: Shield,
  eye: Eye,
  building2: Building2,
  cpu: Cpu,
};
</script>

<template>
  <section
    id="sponsors"
    class="max-w-[75%] mx-auto pb-24 sm:pb-32"
  >
    <h2 class="text-lg md:text-xl text-center mb-6">我们的合作伙伴</h2>

    <div class="mx-auto">
      <Marquee
        class="gap-[4rem]"
        :pauseOnHover="true"
        :fade="true"
        innerClassName="gap-[4rem] flex items-center"
        direction="left"
        :speed="50"
      >
        <div
          v-for="{ icon, name } in sponsors"
          :key="name"
          class="flex items-center justify-center whitespace-nowrap"
        >
          <div class="flex items-center text-lg md:text-xl font-medium text-muted-foreground hover:text-foreground transition-colors">
            <component
              :is="iconMap[icon]"
              class="mr-2 h-5 w-5 md:h-6 md:w-6"
              stroke-width="2"
            />
            {{ name }}
          </div>
        </div>
      </Marquee>
    </div>
  </section>
</template>
